import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SideBarService from "./SideBarService.jsx";
import { Link } from "react-router-dom";
import { utils } from "../../utils/Utils.jsx";
import NavBar from "./nav-bar/NavBar.jsx";
import {
  FaWallet,
  FaLock,
  FaList,
  FaMoneyBillWave,
  FaCoins,
} from "react-icons/fa";
import { IoMdSettings, IoIosArrowForward } from "react-icons/io";
import {
  TbArrowsRightLeft,
  TbWashDryFlat,
  TbDeviceIpadHorizontalDollar,
} from "react-icons/tb";
import { BsFillSendFill, BsPersonWorkspace } from "react-icons/bs";
import { HiWallet } from "react-icons/hi2";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { BiLogOut } from "react-icons/bi";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { BiMoneyWithdraw } from "react-icons/bi";
import { RiBankFill } from "react-icons/ri";
import { PiSquaresFourFill } from "react-icons/pi";
import { ImUsers } from "react-icons/im";
import { SiBitcoinsv } from "react-icons/si";
import { IoCard, IoReceipt, IoSearch } from "react-icons/io5";
import { MdKey } from "react-icons/md";
import "./sideBar.css";
import { IoMdMore } from "react-icons/io";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Button from "react-bootstrap/Button";
import { IoMdArrowRoundBack } from "react-icons/io";
import { HiOutlineMenu } from "react-icons/hi";

class SideBar extends Component {
  state = {
    showThemeRegion: true,
    flagSideBar: false,

    shouldGoBack: false,

    showCollapseSideBarButton: false,
    selectedMenu: "",
    isHovered: false,
  };

  service = new SideBarService();

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log("this.props.config", this.props.config);

    this.checkWindowWidth();

    window.addEventListener("resize", this.checkWindowWidth);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props != prevProps) {
    }

    // Clear selected menu when sidebar becomes collapsed and not hovered
    if (
      this.props.collapsedSideBar &&
      !prevProps.collapsedSideBar &&
      !this.state.isHovered
    ) {
      this.setState({ selectedMenu: "" });
    }
  }

  checkWindowWidth = () => {
    this.windowSize = window.innerWidth;

    if (this.windowSize <= 1600) {
      this.setState({
        showThemeRegion: false,
      });
    } else {
      this.setState({
        showThemeRegion: true,
      });
    }

    // 3 types of layout: no collapse (> 1400px),  (> 1000px &&  < 1400px), and collapse with absolute position (< 1000px)

    this.setState(
      {
        width: this.windowSize,
      },
      () => {
        if (this.windowSize > 900 && this.windowSize <= 1400) {
          this.props.setCollapseSideBar(true);
          this.props.setCollapsedNavBar(null);
        } else if (this.windowSize <= 900) {
          this.props.setCollapseSideBar(null);
          this.props.setCollapsedNavBar(false);
        } else {
          this.props.setCollapsedNavBar(null);
          this.props.setCollapseSideBar(null);
        }
      },
    );
  };

  logout = () => {
    this.service.logout(
      this.props.token,
      utils.goToURL.bind(this),
      this.props,
      this.props.setConfig,
      this.props.setToken,
    );
  };

  toggleTheme = (theme) => {
    this.setState({
      flagSideBar: false,
    });
    this.props.changeTheme(theme);
  };

  selectMenu = (menu) => {
    if (this.state.selectedMenu != menu) {
      this.setState({
        selectedMenu: menu,
      });
    } else {
      this.setState({
        selectedMenu: "",
      });
    }
  };

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
    // Clear selected menu when mouse leaves and sidebar is collapsed
    if (this.props.collapsedSideBar) {
      this.setState({ selectedMenu: "" });
    }
  };

  goBack = () => {
    console.log("Go back clicked");
    console.log("this.props.goBack", this.props.goBack);
    if (
      (this.props.goBack && typeof this.props.goBack === "string") ||
      this.props.goBack instanceof String
    ) {
      utils.goToURL(this.props, this.props.goBack);
    } else if (this.props.goBack) {
      this.props.goBack();
    } else {
      this.props.history.goBack();
    }
  };

  sideBarCollapseConditional = () => {
    if (this.props.collapsedSideBar != null) {
      return !this.props.collapsedSideBar;
    } else {
      return true;
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.props.collapsedNavBar == null ? (
          <div
            class={
              "top-navigation-div" +
              (this.props.collapsedSideBar
                ? " top-navigation-div-collapsed"
                : "")
            }
          >
            {window.location.pathname != "/dashboard" ? (
              <Button
                className={"go-back-button layout-sticky"}
                onClick={this.goBack.bind(this)}
              >
                <IoMdArrowRoundBack class="arrow"></IoMdArrowRoundBack>
                {this.props.localizedText["back"]}
              </Button>
            ) : (
              <>
                {process.env.REACT_APP_ENV != "prod" ? (
                  <div
                    class="version-number"
                    onClick={utils.goToURL.bind(
                      this,
                      this.props,
                      "/dashboard/choose-deposit",
                    )}
                  >
                    {this.props.version}
                  </div>
                ) : null}
              </>
            )}
          </div>
        ) : (
          <NavBar
            goBack={this.goBack.bind(this)}
            localizedText={this.props.localizedText}
            theme={this.props.theme}
            collapsedNavBar={this.props.collapsedNavBar}
            setCollapsedNavBar={this.props.setCollapsedNavBar}
          />
        )}

        <div
          class={
            "side-bar-div" +
            (this.props.collapsedSideBar != null && this.props.collapsedSideBar
              ? " side-bar-div-collapsed"
              : "") +
            (this.props.collapsedNavBar != null && !this.props.collapsedNavBar
              ? " side-bar-div-collapsed-nav-bar"
              : "") +
            (this.props.collapsedNavBar != null && this.props.collapsedNavBar
              ? " side-bar-div-expanded-nav-bar"
              : "")
          }
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {this.props.collapsedSideBar != null ? (
            <>
              {this.sideBarCollapseConditional() ? (
                <HiOutlineMenu
                  class="collapse-button"
                  onClick={() => {
                    this.setState({ selectedMenu: "" });
                    //this.props.setCollapseSideBar(!this.props.collapsedSideBar);
                  }}
                />
              ) : (
                <HiOutlineMenuAlt3
                  class="collapse-button"
                  onClick={() => {
                    //this.props.setCollapseSideBar(!this.props.collapsedSideBar);
                  }}
                />
              )}
            </>
          ) : null}

          {this.props.collapsedNavBar != null && this.props.collapsedNavBar ? (
            <HiOutlineMenuAlt3
              class="collapse-button unexpand-button"
              onClick={() => {
                this.props.setCollapsedNavBar(!this.props.collapsedNavBar);
              }}
            />
          ) : null}

          <div class="side-bar-header">
            <Link to="/dashboard">
              <img
                class="navbar-img"
                src={"/themes/" + this.props.theme + "/logo.png"}
              ></img>
            </Link>
            <Link to="/dashboard" class="nav-title">
              {this.props.config?.company_display_name || process.env.REACT_APP_TITLE}
            </Link>
          </div>
          <div class="side-bar-body">
            <div
              className="sidebar-cmd-k-hint"
              onClick={() => {
                const event = new KeyboardEvent('keydown', { key: 'k', metaKey: true, bubbles: true });
                window.dispatchEvent(event);
              }}
            >
              <IoSearch style={{ fontSize: '0.85rem' }} />
              <span className="nav-text-wrapper">Search</span>
              <kbd>⌘K</kbd>
            </div>

            <div className="side-bar-section-label">Treasury</div>

            <Link
              to="/dashboard"
              className={
                window.location.pathname === "/dashboard"
                  ? "nav-text nav-text-picked"
                  : "nav-text"
              }
            >
              <PiSquaresFourFill class="nav-icon" />
              <span className="nav-text-wrapper">
                {this.props.localizedText["dashboard"]}
              </span>
            </Link>

            <Link
              to="/dashboard/company-cards"
              className={
                window.location.pathname.includes("/dashboard/company-cards")
                  ? "nav-text nav-text-picked"
                  : "nav-text"
              }
            >
              <IoCard class="nav-icon" />
              <span className="nav-text-wrapper">
                {this.props.localizedText["cards"]}
              </span>
            </Link>

            <div className="side-bar-section-label">Move Money</div>

            {utils.conditionalPermission(this.props.config, [
              "can_pay_vendor",
            ]) &&
            utils.conditionalPermission(this.props.config, ["can_pay_peer"]) ? (
              <div class="div-wrapper">
                <div
                  className={
                    window.location.pathname.includes("/dashboard/payment")
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                  onClick={() => {
                    this.selectMenu("pay");
                  }}
                >
                  <BsFillSendFill class="nav-icon" />
                  <span className="nav-text-wrapper">
                    {this.props.localizedText["pay"]}
                  </span>
                  <IoIosArrowForward
                    className={
                      this.state.selectedMenu == "pay"
                        ? "expand-icon expand-less-icon"
                        : "expand-icon"
                    }
                  />
                </div>
                <div
                  className={
                    this.state.selectedMenu == "pay" &&
                    (!this.props.collapsedSideBar || this.state.isHovered)
                      ? "submenu-div submenu-expanded"
                      : "submenu-div"
                  }
                >
                  <Link
                    to="/dashboard/payment/vendors"
                    className={
                      window.location.pathname === "/dashboard/payment/vendors"
                        ? "nav-submenu-text nav-text-picked"
                        : "nav-submenu-text"
                    }
                  >
                    <BsPersonWorkspace class="nav-icon" />
                    <span className="nav-text-wrapper">
                      {this.props.localizedText["vendors"]}
                    </span>
                  </Link>
                  <Link
                    to="/dashboard/payment-in-app-users"
                    className={
                      window.location.pathname ===
                      "/dashboard/payment-in-app-users"
                        ? "nav-submenu-text nav-text-picked"
                        : "nav-submenu-text"
                    }
                  >
                    <ImUsers class="nav-icon" />
                    <span className="nav-text-wrapper">
                      {this.props.localizedText["in-app-users"]}
                    </span>
                  </Link>
                </div>
              </div>
            ) : (
              <>
                {utils.conditionalPermission(this.props.config, ["can_pay"]) ? (
                  <Link
                    to="/dashboard/payment/options"
                    className={
                      window.location.pathname === "/dashboard/payment/options"
                        ? "nav-text nav-text-picked"
                        : "nav-text"
                    }
                  >
                    <BsFillSendFill class="nav-icon" />
                    <span className="nav-text-wrapper">
                      {this.props.localizedText["pay"]}
                    </span>
                  </Link>
                ) : null}
              </>
            )}

            <div class="div-wrapper">
              <div
                className={
                  window.location.pathname.includes("/dashboard/portfolio")
                    ? "nav-text nav-text-picked"
                    : "nav-text"
                }
                onClick={() => {
                  this.selectMenu("portfolio");
                }}
              >
                <HiWallet class="nav-icon" />
                <span className="nav-text-wrapper">
                  {this.props.localizedText["portfolio"]}
                </span>
                <IoIosArrowForward
                  className={
                    this.state.selectedMenu == "portfolio"
                      ? "expand-icon expand-less-icon"
                      : "expand-icon"
                  }
                />
              </div>
              <div
                className={
                  this.state.selectedMenu == "portfolio" &&
                  (!this.props.collapsedSideBar || this.state.isHovered)
                    ? "submenu-div submenu-expanded"
                    : "submenu-div"
                }
              >
                <Link
                  to="/dashboard/portfolio/assets"
                  className={
                    window.location.pathname === "/dashboard/portfolio/assets"
                      ? "nav-submenu-text nav-text-picked"
                      : "nav-submenu-text"
                  }
                >
                  <FaCoins class="nav-icon" />
                  {this.props.localizedText["assets"]}
                </Link>
                <Link
                  to="/dashboard/portfolio/history"
                  className={
                    window.location.pathname === "/dashboard/portfolio/history"
                      ? "nav-submenu-text nav-text-picked"
                      : "nav-submenu-text"
                  }
                >
                  <IoReceipt class="nav-icon" />
                  {this.props.localizedText["transaction-history"]}
                </Link>
              </div>
            </div>

            {utils.countPermittedModules(this.props.config, [
              "can_deposit_bank",
              "can_deposit_crypto",
              "can_deposit_cash",
              "can_deposit_static",
            ]) >= 2 ? (
              <div class="div-wrapper">
                <div
                  className={
                    window.location.pathname.includes("/dashboard/deposit")
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                  onClick={() => {
                    this.selectMenu("deposit");
                  }}
                >
                  <FaWallet class="nav-icon" />
                  <span className="nav-text-wrapper">
                    {this.props.localizedText["deposit"]}
                  </span>
                  <IoIosArrowForward
                    className={
                      this.state.selectedMenu == "deposit"
                        ? "expand-icon expand-less-icon"
                        : "expand-icon"
                    }
                  />
                </div>
                <div
                  className={
                    this.state.selectedMenu == "deposit" &&
                    (!this.props.collapsedSideBar || this.state.isHovered)
                      ? "submenu-div submenu-expanded"
                      : "submenu-div"
                  }
                >
                  {utils.conditionalPermission(this.props.config, [
                    "can_deposit_bank",
                  ]) ? (
                    <Link
                      to="/dashboard/deposit/bank"
                      className={
                        window.location.pathname === "/dashboard/deposit/bank"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <RiBankFill class="nav-icon" />
                      {this.props.localizedText["bank"]}
                    </Link>
                  ) : null}
                  {utils.conditionalPermission(this.props.config, [
                    "can_deposit_crypto",
                  ]) ? (
                    <Link
                      to="/dashboard/deposit/crypto"
                      className={
                        window.location.pathname === "/dashboard/deposit/crypto"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <SiBitcoinsv class="nav-icon" />
                      {this.props.localizedText["crypto"]}
                    </Link>
                  ) : null}
                  {utils.conditionalPermission(this.props.config, [
                    "can_deposit_cash",
                  ]) ? (
                    <Link
                      to="/dashboard/deposit/cash"
                      className={
                        window.location.pathname === "/dashboard/deposit/cash"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <FaMoneyBillWave class="nav-icon" />
                      {this.props.localizedText["cash"]}
                    </Link>
                  ) : null}{" "}
                  {utils.conditionalPermission(this.props.config, [
                    "can_deposit_static",
                  ]) ? (
                    <Link
                      to="/dashboard/deposit/static"
                      className={
                        window.location.pathname === "/dashboard/deposit/static"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <TbWashDryFlat class="nav-icon" />
                      Static
                    </Link>
                  ) : null}
                </div>
              </div>
            ) : (
              <>
                {utils.conditionalPermission(this.props.config, [
                  "can_deposit",
                ]) ? (
                  <Link
                    to="/dashboard/deposit"
                    className={
                      window.location.pathname === "/dashboard/deposit"
                        ? "nav-text nav-text-picked"
                        : "nav-text"
                    }
                  >
                    <FaWallet class="nav-icon" />
                    <span className="nav-text-wrapper">
                      {this.props.localizedText["deposit"]}
                    </span>
                  </Link>
                ) : null}
              </>
            )}

            {utils.countPermittedModules(this.props.config, [
              "can_withdraw_bank",
              "can_withdraw_crypto",
              "can_withdraw_cash",
            ]) >= 2 ? (
              <div class="div-wrapper">
                <div
                  className={
                    window.location.pathname.includes("/dashboard/withdraw")
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                  onClick={() => {
                    this.selectMenu("withdraw");
                  }}
                >
                  <BiMoneyWithdraw class="nav-icon" />
                  <span className="nav-text-wrapper">
                    {this.props.localizedText["withdraw"]}
                  </span>
                  <IoIosArrowForward
                    className={
                      this.state.selectedMenu == "withdraw"
                        ? "expand-icon expand-less-icon"
                        : "expand-icon"
                    }
                  />
                </div>
                <div
                  className={
                    this.state.selectedMenu == "withdraw" &&
                    (!this.props.collapsedSideBar || this.state.isHovered)
                      ? "submenu-div submenu-expanded"
                      : "submenu-div"
                  }
                >
                  {utils.conditionalPermission(this.props.config, [
                    "can_withdraw_bank",
                  ]) ? (
                    <Link
                      to="/dashboard/withdraw/bank"
                      className={
                        window.location.pathname === "/dashboard/withdraw/bank"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <RiBankFill class="nav-icon" />
                      {this.props.localizedText["bank"]}
                    </Link>
                  ) : null}
                  {utils.conditionalPermission(this.props.config, [
                    "can_withdraw_crypto",
                  ]) ? (
                    <Link
                      to="/dashboard/withdraw/crypto"
                      className={
                        window.location.pathname ===
                        "/dashboard/withdraw/crypto"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <SiBitcoinsv class="nav-icon" />
                      {this.props.localizedText["crypto"]}
                    </Link>
                  ) : null}
                  {utils.conditionalPermission(this.props.config, [
                    "can_withdraw_cash",
                  ]) ? (
                    <Link
                      to="/dashboard/withdraw/cash"
                      className={
                        window.location.pathname === "/dashboard/withdraw/cash"
                          ? "nav-submenu-text nav-text-picked"
                          : "nav-submenu-text"
                      }
                    >
                      <FaMoneyBillWave class="nav-icon" />
                      {this.props.localizedText["cash"]}
                    </Link>
                  ) : null}
                </div>
              </div>
            ) : (
              <>
                {utils.conditionalPermission(this.props.config, [
                  "can_withdraw",
                ]) ? (
                  <Link
                    to="/dashboard/withdraw"
                    className={
                      window.location.pathname === "/dashboard/withdraw"
                        ? "nav-text nav-text-picked"
                        : "nav-text"
                    }
                  >
                    <BiMoneyWithdraw class="nav-icon" />
                    <span className="nav-text-wrapper">
                      {this.props.localizedText["withdraw"]}
                    </span>
                  </Link>
                ) : null}
              </>
            )}

            {utils.conditionalPermission(this.props.config, ["can_convert"]) ? (
              <Link
                to="/dashboard/conversion"
                className={
                  window.location.pathname === "/dashboard/conversion"
                    ? "nav-text nav-text-picked"
                    : "nav-text"
                }
              >
                <TbArrowsRightLeft class="nav-icon" />
                <span className="nav-text-wrapper">
                  {this.props.localizedText["convert"]}
                </span>
              </Link>
            ) : null}

            {process.env.REACT_APP_ENV != "prod" ? (
              <>
                {utils.countPermittedModules(this.props.config, [
                  "can_pay_me_credit_card",
                  "can_pay_me_crypto",
                  "can_pay_me_plugins",
                ]) >= 2 ? (
                  <div class="div-wrapper">
                    <div
                      className={
                        window.location.pathname.includes("pay-me")
                          ? "nav-text nav-text-picked"
                          : "nav-text"
                      }
                      onClick={() => {
                        this.selectMenu("payment-processor");
                      }}
                    >
                      <TbDeviceIpadHorizontalDollar class="nav-icon" />

                      <span className="nav-text-wrapper">
                        {this.props.localizedText["payment-processor"]}
                      </span>
                      <IoIosArrowForward
                        className={
                          this.state.selectedMenu == "payment-processor"
                            ? "expand-icon expand-less-icon"
                            : "expand-icon"
                        }
                      />
                    </div>
                    <div
                      className={
                        this.state.selectedMenu == "payment-processor" &&
                        (!this.props.collapsedSideBar || this.state.isHovered)
                          ? "submenu-div submenu-expanded"
                          : "submenu-div"
                      }
                    >
                      {utils.conditionalPermission(this.props.config, [
                        "can_pay_me_credit_card",
                      ]) ? (
                        <Link
                          to="/dashboard/pay-me/credit-card"
                          className={
                            window.location.pathname ===
                            "/dashboard/pay-me/credit-card"
                              ? "nav-submenu-text nav-text-picked"
                              : "nav-submenu-text"
                          }
                        >
                          <IoCard class="nav-icon" />
                          {
                            this.props.localizedText[
                              "process-credit-card-payment"
                            ]
                          }
                        </Link>
                      ) : null}
                      {utils.conditionalPermission(this.props.config, [
                        "can_pay_me_crypto",
                      ]) ? (
                        <Link
                          to="/dashboard/pay-me/crypto"
                          className={
                            window.location.pathname ===
                            "/dashboard/pay-me/crypto"
                              ? "nav-submenu-text nav-text-picked"
                              : "nav-submenu-text"
                          }
                        >
                          <SiBitcoinsv class="nav-icon" />
                          {this.props.localizedText["process-crypto-payment"]}
                        </Link>
                      ) : null}{" "}
                      {utils.conditionalPermission(this.props.config, [
                        "can_pay_me",
                      ]) ? (
                        <Link
                          to="/dashboard/pay-me/bulk-sale"
                          className={
                            window.location.pathname ===
                            "/dashboard/pay-me/bulk-sale"
                              ? "nav-submenu-text nav-text-picked"
                              : "nav-submenu-text"
                          }
                        >
                          <FaList class="nav-icon" />
                          {this.props.localizedText["bulk-sale"]}
                        </Link>
                      ) : null}
                      {utils.conditionalPermission(this.props.config, [
                        "can_pay_me_plugins",
                      ]) ? (
                        <Link
                          to="/dashboard/pay-me/plugins/plugins"
                          className={
                            window.location.pathname ===
                            "/dashboard/pay-me/plugins/plugins"
                              ? "nav-submenu-text nav-text-picked"
                              : "nav-submenu-text"
                          }
                        >
                          <MdKey class="nav-icon" />
                          {this.props.localizedText["plugins"]}
                        </Link>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  <>
                    {utils.conditionalPermission(this.props.config, [
                      "can_pay_me",
                    ]) ? (
                      <Link
                        to="/dashboard/pay-me"
                        className={
                          window.location.pathname === "/dashboard/pay-me"
                            ? "nav-text nav-text-picked"
                            : "nav-text"
                        }
                      >
                        <TbDeviceIpadHorizontalDollar class="nav-icon" />
                        <span className="nav-text-wrapper">
                          {this.props.localizedText["payment-processor"]}
                        </span>
                      </Link>
                    ) : null}
                  </>
                )}
              </>
            ) : null}

            {this.props.config &&
            this.props.config.roles &&
            this.props.config.roles.some((role) => role.name == "Blox_Admin") ? (
              <>
                <div className="side-bar-section-label">Operations</div>

                <Link
                  to="/dashboard/admin/journey"
                  className={
                    window.location.pathname.includes("/dashboard/admin/journey")
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                >
                  <IoSearch class="nav-icon" />
                  <span className="nav-text-wrapper">
                    Client Onboarding Monitoring
                  </span>
                </Link>

                <div className="side-bar-section-label">Partners</div>

                <Link
                  to="/dashboard/admin/card-payments"
                  className={
                    window.location.pathname ===
                    "/dashboard/admin/card-payments"
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                >
                  <IoCard class="nav-icon" />
                  <span className="nav-text-wrapper">
                    Card Payments Config
                  </span>
                </Link>

                <Link
                  to="/dashboard/admin/company-config"
                  className={
                    window.location.pathname ===
                    "/dashboard/admin/company-config"
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                >
                  <IoCard class="nav-icon" />
                  <span className="nav-text-wrapper">
                    Company Configuration
                  </span>
                </Link>

                <Link
                  to="/dashboard/admin/blocklist"
                  className={
                    window.location.pathname ===
                    "/dashboard/admin/blocklist"
                      ? "nav-text nav-text-picked"
                      : "nav-text"
                  }
                >
                  <IoCard class="nav-icon" />
                  <span className="nav-text-wrapper">
                    Registration Blocklist
                  </span>
                </Link>
              </>
            ) : null}

            <div className="side-bar-section-label">Tools</div>

            {utils.conditionalPermission(this.props.config, [
              "can_mreport_payment",
            ]) ? (
              <Link
                to="/dashboard/monthy-payment-report"
                className={
                  window.location.pathname ===
                  "/dashboard/monthy-payment-report"
                    ? "nav-text nav-text-picked"
                    : "nav-text"
                }
              >
                <HiOutlineDocumentReport class="nav-icon" />
                <span className="nav-text-wrapper">
                  {this.props.localizedText["monthly-payment-report"]}
                </span>
              </Link>
            ) : null}

            <Link
              to="/dashboard/settings"
              className={
                window.location.pathname === "/dashboard/settings"
                  ? "nav-text nav-text-picked"
                  : "nav-text"
              }
            >
              <IoMdSettings class="nav-icon" />
              <span className="nav-text-wrapper">
                {this.props.localizedText["settings"]}
              </span>
            </Link>
          </div>
          <div class="side-bar-footer">
            <div class="footer-line" />
            <OverlayTrigger
              trigger="click"
              placement={"top"}
              rootClose={true}
              overlay={
                <Popover className="side-bar-popover">
                  <div
                    class="side-bar-sub-menu-item"
                    onClick={this.logout.bind(this)}
                  >
                    <BiLogOut class="side-bar-item-icon"></BiLogOut>
                    {this.props.localizedText["logout"]}
                  </div>

                  <div
                    class="side-bar-sub-menu-item"
                    onClick={() => {
                      utils.goToURL(this.props, "/dashboard/settings");
                      document.body.click();
                    }}
                  >
                    <IoMdSettings class="side-bar-item-icon" />
                    {this.props.localizedText["settings"]}
                  </div>
                  <div
                    class="side-bar-sub-menu-item"
                    onClick={this.props.handleInactivity}
                  >
                    <FaLock class="side-bar-item-icon" />
                    {this.props.localizedText["lock-session"]}
                  </div>
                </Popover>
              }
            >
              <div className="account-info">
                <div class="info">
                  <div class="info-name">
                    {this.props.config.fname + " " + this.props.config.lname}
                  </div>
                  <div class="info-email">
                    {this.props.config ? this.props.config.email : ""}
                  </div>
                </div>
                <IoMdMore />
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(SideBar);
